// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1NZAQ","info":"PatientInfo_info__3hnvC"};